<template>
  <div class="BcApprovalGraph w-40">
    <div class="flex justify-between items-center w-full text-xxs px-1">
      <span class="flex justify-center items-center">
        {{ stats.approved }} 
        <aw-icon 
          icon="tick"
          class="w-3 h-3"
        />
        /
        {{ stats.disapproved }} 
        <aw-icon 
          icon="close"
          class="w-3 h-3"
        />
        /
        {{ stats.waiting }} 
        <aw-icon 
          icon="question-simple"
          class="w-3 h-3"
        />
      </span>
      <span class="flex justify-center items-center">
       {{ $t('In total')}}: {{ stats.total }}
      </span>
    </div>
    <div class="flex justify-start items-center w-full rounded-md overflow-hidden">
      <div
        v-if="stats.approved"
        class="bg-bc-blue h-1.5"
        :style="approvalsWidth"
      />
      <div 
        v-if="stats.disapproved"
        class="bg-bc-red h-1.5"
        :style="disapprovalsWidth"
      />
      <div 
        v-if="stats.waiting"
        class="bg-gray-400 h-1.5"
        :style="waitingWidth"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stats: {
      type: Object,
      default: null,
    }
  },
  computed: {
    approvalsWidth() {
      return {
        'width': 100 / this.stats.total * this.stats.approved + '%',
      }
    },
    disapprovalsWidth() {
      return {
        'width': 100 / this.stats.total * this.stats.disapproved + '%',
      }
    },
    waitingWidth() {
      return {
        'width': 100 / this.stats.total * this.stats.waiting + '%',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.BcApprovalGraph {
  min-width: 10rem;
  
  svg {
    min-width: 0.75rem;
  }
}
</style>
